var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('regular-input',{attrs:{"value":_vm.input,"type":"text","placeholder":_vm.criteria},on:{"input":function($event){_vm.input = $event}}})}
var staticRenderFns = []
export { render, staticRenderFns }